<template>
  <div>
    <HeadersDetalhesResumo
      :apelido="imovel.apelido"
      :proprietario="imovel.proprietario"
      :tipo="imovel.tipo"
      :savoynet="imovel.savoynet"
    >
    </HeadersDetalhesResumo>
    <v-layout row wrap align-center class="secondary white--text detalhes-header">
      <v-flex xs2>
        <v-container fluid class="py-2">      
          <v-layout row wrap>
            <v-flex xs12 class="text-xs-left">
              <v-btn icon :to="({ name: 'ImoveisDetalhesResumo', params: { id: $route.params.id } })" class="ma-0 white--text">
                <v-icon>close</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
      <v-flex xs8>
        <v-container fluid class="py-2">      
          <v-layout row wrap>
            <v-flex xs12>
              <span class="subtitulo">Área</span>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
      <v-flex xs2>
        <v-container fluid class="py-2">
          <v-layout row wrap>
            <v-flex xs12 v-if="canEditArea">
              <v-btn flat @click.stop="onSubmit" :disabled="isFormInvalid">
                <span class="subtitulo">Salvar</span>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
    <form v-on:submit.prevent="onSubmit">
      <v-layout row wrap class="pt-5 readonly-form" :class="{ 'readonly-form--blocked': !canEditArea }">
        <v-flex xs12 sm10 offset-sm1 md8 offset-md2>
          <v-container fluid>
            <v-layout row wrap class="mt-3">
              <v-flex xs12>
                <v-text-field
                  v-model="form.fields.area_terreno"
                  label="Área do terreno"
                  @keydown="formatArea"
                  suffix="m²"
                >
                </v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model="form.fields.area_construida"
                  label="Área construída"
                  @keydown="formatArea"
                  suffix="m²"
                >
                </v-text-field>
              </v-flex>
              <v-flex xs12>              
                <v-text-field
                  v-model="form.fields.area_util"
                  label="Área útil"
                  @keydown="formatArea"
                  suffix="m²"
                >
                </v-text-field>
              </v-flex>
              <v-flex xs12 class="switch-fix">
                <strong><span v-if="form.fields.calcada">Com</span><span v-else>Sem</span> calçada</strong>
                <v-switch
                  v-model="form.fields.calcada" 
                  color="secondary"
                  hide-details
                >
                </v-switch>
              </v-flex>
              <v-flex xs12 class="switch-fix">
                <strong><span v-if="form.fields.muro">Com</span><span v-else>Sem</span> muro</strong>
                <v-switch
                  v-model="form.fields.muro" 
                  color="secondary"
                  hide-details
                >
                </v-switch>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
      </v-layout>
    </form>
    <v-layout row wrap class="pt-5 readonly-form" :class="{ 'readonly-form--blocked': !canEditArea }">
      <v-flex xs12 sm10 offset-sm1 md8 offset-md2>
        <gmap-map
          class="map-container"
          v-if="this.map.center.lat !== null && this.map.center.lng !== null"
          :center="map.center"
          :zoom="19"
          :options="{ clickableIcons: false, disableDoubleClickZoom: true, streetViewControl: false }"
          style="width: 100%; height: 400px; margin-bottom: 30px;"
          ref="map"
          @idle="calculateArea"
        >
          <gmap-polygon
            v-if="polygon.paths.length > 0"
            :options="polygonOptions"
            :paths="polygon.paths"
            :editable="canEditArea"
            @paths_changed="updateEdited($event)"
            @dblclick="handleClickForDelete"
            ref="polygon"
          >
          </gmap-polygon>
        </gmap-map>
      </v-flex>
    </v-layout>
    <v-container fluid v-if="polygon.edited && polygon.area > 0" class="py-0 mt-2 mb-4 text-xs-center">
      <v-layout row wrap>
        <p class="caption" style="width: 100%;">Cálculo aproximado da área desenhada: <span class="secondary--text">{{ Math.round(polygon.area) }} m²</span></p>
      </v-layout>
    </v-container>
    <ButtonsObservacoesAnexos></ButtonsObservacoesAnexos>
  </div>
</template>

<script>
  import _ from 'lodash'
  import axios from 'axios'
  import { apiURL } from '@/config'
  import HeadersDetalhesResumo from '../Headers/HeadersDetalhesResumo'
  import ButtonsObservacoesAnexos from './ButtonsObservacoesAnexos'
  
  export default {
    components: {
      HeadersDetalhesResumo,
      ButtonsObservacoesAnexos
    },
    data () {
      return {
        form: {
          fields: {
            area_terreno: '',
            area_construida: '',
            area_util: '',
            calcada: false,
            muro: false,
            desenho: []
          }
        },
        map: {
          center: {
            lat: null,
            lng: null
          }
        },
        polygon: {
          paths: [],
          edited: false,
          area: 0,
          distanciaPontos: 0.0001,
          options: {
            strokeWeight: 0,
            fillColor: '',
            draggable: true
          }
        }
      }
    },
    computed: {
      imovel () {
        return this.$store.getters['imoveis/detalhes']
      },
      canViewArea () {
        return this.$hasGranularPermission('area', 'view')
      },
      canEditArea () {
        return this.$hasGranularPermission('area', 'edit')
      },
      isFormInvalid () {
        return Object.keys(this.fields).some(key => this.fields[key].invalid) || _.isEmpty(_.omitBy(this.form.fields, _.isEmpty))
      },
      polygonOptions () {
        return Object.assign({}, this.polygon.options, {
          draggable: this.canEditArea
        })
      }
    },
    watch: {
      imovel () {
        if (this.imovel.hasOwnProperty('area')) {
          this.form.fields = Object.assign({}, this.imovel.area.data)
        }
        if (_.has(this.imovel, 'endereco.data.latitude') && _.has(this.imovel, 'endereco.data.longitude')) {
          if (_.has(this.imovel, 'area.data.desenho') && this.imovel.area.data.desenho !== null && this.imovel.area.data.desenho.length > 1) {
            this.map.center.lat = this.imovel.area.data.desenho[0].lat
            this.map.center.lng = this.imovel.area.data.desenho[0].lng

            this.polygon.paths = this.imovel.area.data.desenho
            this.polygon.edited = true
          } else {
            this.map.center.lat = this.imovel.endereco.data.latitude
            this.map.center.lng = this.imovel.endereco.data.longitude

            this.polygon.paths.push({ lat: this.map.center.lat, lng: this.map.center.lng })
            this.polygon.paths.push({ lat: this.map.center.lat, lng: this.map.center.lng + this.polygon.distanciaPontos })
            this.polygon.paths.push({ lat: this.map.center.lat + this.polygon.distanciaPontos, lng: this.map.center.lng + this.polygon.distanciaPontos })
            this.polygon.paths.push({ lat: this.map.center.lat + this.polygon.distanciaPontos, lng: this.map.center.lng })
          }
        }
      },
      'polygon.paths' () {
        if (this.polygon.edited) {
          this.form.fields.desenho = this.polygon.paths
        }
      },
      'polygon.edited' (value) {
        if (value) {
          this.polygon.options.fillColor = '#F37021'
        } else {
          this.polygon.options.fillColor = 'grey'
        }
      },
      'form.fields.area_terreno' (value) {
        this.form.fields.area_terreno = this.formatArea(value)
      },
      'form.fields.area_construida' (value) {
        this.form.fields.area_construida = this.formatArea(value)
      },
      'form.fields.area_util' (value) {
        this.form.fields.area_util = this.formatArea(value)
      }
    },
    methods: {
      updateEdited (resultPaths) {
        if (!this.canEditArea) return
        const newPolygonPaths = []
        this.$refs.polygon.$polygonObject.getPath().forEach((path) => {
          newPolygonPaths.push({ lat: path.lat(), lng: path.lng() })
        })
        this.calculateArea()
        this.polygon.paths = newPolygonPaths
        this.polygon.edited = true
      },
      calculateArea () {
        /* eslint-disable */
        if (google && _.has(google, 'maps.geometry.spherical')) {
          this.polygon.area = google.maps.geometry.spherical.computeArea(this.$refs.polygon.$polygonObject.getPath())
        }
        /* eslint-enable */
      },
      handleClickForDelete ($event) {
        if (!this.canEditArea) return
        if ($event.vertex) {
          this.$refs.polygon.$polygonObject.getPaths()
            .getAt($event.path)
            .removeAt($event.vertex)
        }
      },
      formatArea (area) {
        if (area === null) {
          return ''
        }

        let value = area
        let newValue = String(value).replace(/\./g, '').replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1.')

        return newValue
      },
      onSubmit () {
        if (!this.canEditArea) return
        this.$store.dispatch('utils/showLoading')

        this.$validator.validateAll().then((result) => {
          const fieldsToSubmit = Object.assign({}, this.form.fields)
          fieldsToSubmit.area_terreno = (fieldsToSubmit.area_terreno ? parseInt(fieldsToSubmit.area_terreno.replace(/\./g, '')) : null)
          fieldsToSubmit.area_construida = (fieldsToSubmit.area_construida ? parseInt(fieldsToSubmit.area_construida.replace(/\./g, '')) : null)
          fieldsToSubmit.area_util = (fieldsToSubmit.area_util ? parseInt(fieldsToSubmit.area_util.replace(/\./g, '')) : null)
          fieldsToSubmit.desenho = (fieldsToSubmit.desenho !== null && fieldsToSubmit.desenho.length > 0 ? JSON.stringify(fieldsToSubmit.desenho) : null)

          if (result) {
            axios.patch(`${apiURL}/imoveis/${this.$route.params.id}`, { area: fieldsToSubmit }).then((response) => {
              this.$router.push({ name: 'ImoveisDetalhesResumo', params: { id: response.data.data.id } })
              this.$store.dispatch('utils/hideLoading')
            }, () => {
              this.$store.dispatch('utils/showSnackbar', {
                text: 'Servidor indisponível. Tente novamente mais tarde.'
              })
              this.$store.dispatch('utils/hideLoading')
            })
          } else {
            this.$store.dispatch('utils/showSnackbar', {
              type: 'error',
              text: 'Preencha os campos corretamente'
            })
            this.$store.dispatch('utils/hideLoading')
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// DetalhesArea.vue?5dacadb7